import './Section2Component.css'
export const Section2Component = () => {


    return (
        <div className="soft_gray_bg py-5 pb-lg-5 px-2 px-lg-0 anchor_mt">      
            <div className="container text-center section_2">
                
                <p className='rubik_regular m-0 text-section-2'>Antes éramos <span className='rubik_bold'>
                    Giros y Finanzas
                    </span>, hoy somos un banco que brinda más respaldo, <br/> servicio, tecnologia y nuevas oportunidades para los que viven en nuestro país y los<br/> que residen en el exterior.
                </p>
            </div>
        </div>
    )
}